import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 39 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 0V24H38.9996C38.1404 23.8906 37.4265 23.7593 36.9055 23.6016C35.1957 23.0838 33.5478 22.3587 31.9942 21.4404C29.166 19.7689 26.8043 17.26 22.0809 12.2422L22.0808 12.2421L18.8948 8.85752C17.3116 7.17571 16.5201 6.3348 15.6882 5.60223C12.1017 2.44383 7.70194 0.507822 3.06359 0.0470471C2.7459 0.0154874 1.56496 0.00255468 0.000646949 0H0Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }